import { Link } from "react-router-dom";
import { Bell, ArrowRight } from "lucide-react";

export function NotifyCTA({
  title = "Never miss an update",
  text = "Get an email when we post new standings, tournaments, promos, merch — or when we go live. Pick exactly what you want to hear about.",
}) {
  return (
    <section className="bg-[#0B0B0C]" data-testid="notify-cta">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="relative overflow-hidden rounded-2xl border border-[#1E63C4]/40 bg-gradient-to-br from-[#11131a] to-[#0B0B0C] px-6 py-10 sm:px-10 sm:py-12">
          <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-[#1E63C4]/20 blur-3xl" aria-hidden="true" />
          <div className="relative flex flex-col items-start gap-5 md:flex-row md:items-center md:justify-between">
            <div className="max-w-2xl">
              <div className="inline-flex items-center gap-2 rounded-full bg-[#1E63C4]/15 px-3 py-1 text-[#62A8E5] text-sm font-semibold mb-3">
                <Bell className="h-4 w-4" /> Stay in the loop
              </div>
              <h2 className="font-heading text-2xl sm:text-3xl font-bold text-white">{title}</h2>
              <p className="mt-2 text-gray-300 leading-relaxed">{text}</p>
            </div>
            <Link
              to="/notify"
              data-testid="notify-cta-button"
              className="shrink-0 inline-flex items-center gap-2 bg-[#E11D2A] text-white rounded-md px-6 py-3 font-semibold hover:bg-[#c41320] transition-colors"
            >
              <Bell className="h-5 w-5" /> Get notified <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
